<app-header
    [clicked]="clickedOutside"
    [langSel]="languageSelected"
    (changeMegaMenuCondition)="changeMenuCondition($event)"
    (selectedLanguage)="switchLanguageHandler($event)"
    (click)="updateSubmitButton()"
></app-header>
<div
    *ngIf="!submittedSuccessfully"
    class="tw-flex tw-flex-col lg:tw-justify-center lg:tw-items-start lg:tw-flex-row tw-bg-[#F4F4F4] tw-gap-[12vw] md:tw-gap-[5vw] 2xl:tw-gap-[2vw] tw-py-20"
    (click)="updateSubmitButton()"
>
    <div class="tw-flex tw-flex-col tw-max-w-[500px] tw-px-[10vw] lg:tw-px-[5vw]">
        <div class="tw-text-[21px] tw-text-[#000000]">
            {{ "SUPPORT.HAVE_A_QUESTION?" | translate }}
        </div>
        <div class="tw-text-[36px] tw-mt-2 tw-text-[#212121]">
            {{ "SUPPORT.MAIN_TITLE" | translate }}
        </div>
        <hr class="tw-mt-10" style="border: 1px solid #c1c1c1" />
        <div
            class="tw-mt-7 tw-pt-2 tw-text-xl tw-flex tw-flex-col tw-text-[#7A7A7A] tw-leading-7"
        >
            <div class="tw-text-[16px]">
                {{ "SUPPORT.ADDRESS_ONE" | translate }}
            </div>
            <div class="tw-text-[16px]">
                {{ "SUPPORT.ADDRESS_ADDED" | translate }}
            </div>
            <div class="tw-text-[16px]">
                {{ "SUPPORT.ADDRESS_TWO" | translate }}
            </div>
            <div class="tw-text-[16px]">
                {{ "SUPPORT.ADDRESS_THREE" | translate }}
            </div>
            <div class="tw-text-[16px]">
                {{ "SUPPORT.ADDRESS_FOUR" | translate }}
            </div>
            <div class="tw-pt-5 tw-text-[16px]">{{ "SUPPORT.EMAIL" | translate }}</div>
        </div>
    </div>
    <form id="businessCardFormId" [formGroup]="businessCardForm" (keydown.enter)="$event.preventDefault()">
        <div
            class="tw-max-w-[800px] business-card-form tw-flex tw-flex-col tw-gap-10 tw-px-[10vw] lg:tw-px-[5vw]"
        >
            <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-8">
                <div class="tw-flex tw-flex-col tw-bg-[#F4F4F4]">
                    <label
                        class="tw-text-xs tw-font-[500] tw-mb-[5px]"
                        >
                        {{ "FORM.FIRST_NAME" | translate}}
                        <span class="tw-text-red-400">*</span>
                    </label>
                    <input
                        class="tw-placeholder-[#8d8d8d]"
                        placeholder="{{ 'CONTACT_US.FIRST_NAME' | translate }}"
                        formControlName="firstName"
                        (click)="updateSubmitButton()"
                        #firstName
                    />
                    <div
                        class="tw-mt-2 tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-black"
                        *ngIf="submitted && f.firstName.errors"
                    >
                        <mat-icon class="error-icon !tw-overflow-visible">error_outline</mat-icon>
                        <span
                            *ngIf="f.firstName.errors.required"
                            class="tw-pt-3 tw-pb-3"
                        >
                            {{ "ERROR.CONTACT_US_FIRST_NAME" | translate }}
                        </span>
                        <span
                            *ngIf="f.firstName.errors.pattern"
                            class="tw-pt-3 tw-pb-3"
                        >
                            {{ "FORM.FIRST_NAME" | translate }}
                            {{ "ERROR.MUST_BE_ALPHABET_ONLY" | translate }}
                        </span>
                        <span
                            *ngIf="
                                (f.firstName.errors.minlength ||
                                f.firstName.errors.maxlength) &&
                                !f.firstName.errors.pattern
                            "
                            class="tw-pt-3 tw-pb-3"
                        >
                            {{ "FORM.FIRST_NAME" | translate }}
                            {{ "ERROR.MUST_BE_MIN_2_OR_MAX_50_CHAR" | translate }}
                        </span>
                    </div>
                </div>
                <div class="tw-flex tw-flex-col tw-bg-[#F4F4F4]">
                    <label
                        class="tw-text-xs tw-font-[500] tw-mb-[5px]"
                    >
                        {{ "FORM.LAST_NAME" | translate }}
                        <span class="tw-text-red-400">*</span>
                    </label>
                    <input
                        placeholder="{{ 'CONTACT_US.LAST_NAME' | translate }}"
                        class="tw-placeholder-[#8d8d8d]"
                        formControlName="lastName"
                        (click)="updateSubmitButton()"
                        #lastName
                    />
                    
                    <div
                        class="tw-mt-2 tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-black"
                        *ngIf="submitted && f.lastName.errors"
                    >
                        <mat-icon class="error-icon !tw-overflow-visible">error_outline</mat-icon>
                        <span
                            *ngIf="f.lastName.errors.required"
                            class="tw-pt-3 tw-pb-3"
                        >
                            {{ "ERROR.CONTACT_US_LAST_NAME" | translate }}
                        </span>
                        <span
                            *ngIf="f.lastName.errors.pattern"
                            class="tw-pt-3 tw-pb-3"
                        >
                            {{ "FORM.LAST_NAME" | translate }}
                            {{ "ERROR.MUST_BE_ALPHABET_ONLY" | translate }}
                        </span>
                        <span
                            *ngIf="
                                (f.lastName.errors.minlength ||
                                f.lastName.errors.maxlength) &&
                                !f.lastName.errors.pattern
                            "
                            class="tw-pt-3 tw-pb-3"
                        >
                            {{ "FORM.LAST_NAME" | translate }}
                            {{ "ERROR.MUST_BE_MIN_2_OR_MAX_50_CHAR" | translate }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-8">
                <div class="tw-flex tw-flex-col tw-bg-[#F4F4F4]">
                    <label
                        class="tw-text-xs tw-font-[500] tw-mb-[5px]"
                    >
                        {{ "FORM.PHONE" | translate }}
                        <span class="tw-text-red-400">*</span>
                    </label>
                    <input
                        class="tw-placeholder-[#8d8d8d]"
                        placeholder="+(60x) xxx xxxx"
                        formControlName="phoneNumber"
                        (click)="updateSubmitButton()"
                        (input)="keyPressNumbers($event)"
                        (paste)="pasteNumberOnly($event)"
                        maxlength="17"
                        #phoneNumber
                    />
                    <div
                        class="tw-mt-2 tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-black"
                        *ngIf="submitted && f.phoneNumber.errors"
                    >
                        <mat-icon class="error-icon !tw-overflow-visible">error_outline</mat-icon>
                        <span
                            *ngIf="f.phoneNumber.errors.required"
                            class="tw-pt-3 tw-pb-3"
                        >
                            {{ "ERROR.CONTACT_US_PHONE_NO" | translate }}
                        </span>
                        <span
                            *ngIf="
                                f.phoneNumber.errors.minlength ||
                                f.phoneNumber.errors.maxlength
                            "
                            class="tw-pt-3 tw-pb-3"
                        >
                            {{ "FORM.PHONE" | translate }}
                            {{ "ERROR.MUST_BE_MIN_6_OR_MAX_11_DIGITS" | translate }}
                        </span>
                    </div>
                </div>
                <div class="tw-flex tw-flex-col tw-bg-[#F4F4F4]">
                    <label class="tw-text-xs tw-font-[500] tw-mb-[5px]">{{ "JOB_TITLE" | translate }}</label>
                    <input
                        placeholder="{{ 'JOB_TITLE' | translate }}"
                        class="tw-placeholder-[#8d8d8d]"
                        formControlName="jobTitle"
                        (click)="updateSubmitButton()"
                        (input)="alphabetOnly($event)"
                        #jobTitle
                    />
                    <div
                        class="tw-mt-2 tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-black"
                        *ngIf="submitted && f.jobTitle.errors"
                    >
                        <mat-icon class="error-icon !tw-overflow-visible">error_outline</mat-icon>
                        <span
                            *ngIf="f.jobTitle.errors.required"
                            class="tw-pt-3 tw-pb-3"
                        >
                            {{ "ERROR.BUSINESS_JOB_TITLE" | translate }}
                        </span>
                        <span
                            *ngIf="
                                f.jobTitle.errors.maxlength &&
                                !f.jobTitle.errors.pattern
                            "
                            class="tw-pt-3 tw-pb-3"
                        >
                            {{ "JOB_TITLE" | translate }}
                            {{ "ERROR.MUST_NOT_BE_MORE_THAN_100_CHAR" | translate }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="tw-flex tw-flex-col tw-bg-[#F4F4F4]">
                <label class="tw-text-xs tw-font-[500] tw-mb-[5px]">
                    {{ "FORM.EMAIL" | translate }}
                    <span class="tw-text-red-400">*</span>
                </label>
                <input
                    class="tw-placeholder-[#8d8d8d]"
                    placeholder="{{ 'FORM.EMAIL' | translate }}"
                    formControlName="email"
                    (click)="updateSubmitButton()"
                    #email
                />
                <div
                    class="tw-mt-2 tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-black"
                    *ngIf="submitted && f.email.errors"
                >
                    <mat-icon class="error-icon !tw-overflow-visible">error_outline</mat-icon>
                    <span
                        *ngIf="f.email.errors.required"
                        class="tw-pt-3 tw-pb-3"
                    >
                        {{ "ERROR.CONTACT_US_EMAIL" | translate }}
                    </span>
                    <span
                        *ngIf="f.email.errors.pattern &&
                        !f.email.errors.maxlength"
                        class="tw-pt-3 tw-pb-3"
                    >
                        {{ "ERROR.CONTACT_US_EMAIL" | translate }}
                    </span>
                    <span
                        *ngIf="
                            f.email.errors.maxlength
                        "
                        class="tw-pt-3 tw-pb-3"
                    >
                        {{ "FORM.EMAIL" | translate }}
                        {{ "ERROR.MUST_NOT_BE_MORE_THAN_100_CHAR" | translate }}
                    </span>
                </div>
            </div>
            <div class="tw-flex tw-flex-col tw-bg-[#F4F4F4]">
                <label class="tw-text-xs tw-font-[500] tw-mb-[5px]">{{ "FORM.COMPANY" | translate }}</label>
                <input
                    class="tw-placeholder-[#8d8d8d]"
                    placeholder="{{ 'CONTACT_US.COMPANY_NAME' | translate }}"
                    formControlName="company"
                    (click)="updateSubmitButton()"
                    (input)="alphaNumberOnly($event)"
                    #company
                />
                <div
                    class="tw-mt-2 tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-black"
                    *ngIf="submitted && f.company.errors"
                >
                    <mat-icon class="error-icon !tw-overflow-visible"
                        >error_outline</mat-icon
                    >
                    <span
                        *ngIf="f.company.errors.required"
                        class="tw-pt-3 tw-pb-3"
                    >
                        {{ "ERROR.CONTACT_US_COMPANY_NAME" | translate }}
                    </span>
                    <span
                        *ngIf="f.company.errors.maxlength"
                        class="tw-pt-3 tw-pb-3"
                    >
                        {{ "CONTACT_US.COMPANY_NAME" | translate }}
                        {{ "ERROR.MUST_NOT_BE_MORE_THAN_100_CHAR" | translate }}
                    </span>
                </div>
            </div>
            <div class="tw-flex tw-flex-col tw-bg-[#F4F4F4]">
                <label class="tw-text-xs tw-font-[500] tw-mb-[5px]">{{ "ADDRESS" | translate }}</label>
                <input
                    class="tw-placeholder-[#8d8d8d]"
                    placeholder="{{ 'ADDRESS' | translate }}"
                    formControlName="address"
                    (click)="updateSubmitButton()"
                    #address
                />
                <div
                    class="tw-mt-2 tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-black"
                    *ngIf="submitted && f.address.errors"
                >
                    <mat-icon class="error-icon !tw-overflow-visible">error_outline</mat-icon>
                    <span
                        *ngIf="f.address.errors.required"
                        class="tw-pt-3 tw-pb-3"
                    >
                        {{ "ERROR.BUSINESS_ADDRESS" | translate }}
                    </span>
                    <span
                        *ngIf="f.address.errors.maxlength"
                        class="tw-pt-3 tw-pb-3"
                    >
                        {{ "ADDRESS" | translate }}
                        {{ "ERROR.MUST_NOT_BE_MORE_THAN_100_CHAR" | translate }}
                    </span>
                </div>
                <input
                    class="tw-placeholder-[#8d8d8d] tw-mt-[40px]"
                    placeholder="{{ 'ADDRESS' | translate }}"
                    formControlName="address2"
                    (click)="updateSubmitButton()"
                    #address2
                />
                <div
                    class="tw-mt-2 tw-flex tw-gap-2 tw-pt-1 tw-items-center tw-text-black"
                    *ngIf="submitted && f.address2.errors"
                >
                    <mat-icon class="error-icon !tw-overflow-visible">error_outline</mat-icon>
                    <span
                        *ngIf="f.address2.errors.required"
                        class="tw-pt-3 tw-pb-3"
                    >
                        {{ "ERROR.BUSINESS_ADDRESS" | translate }}
                    </span>
                    <span
                        *ngIf="f.address2.errors.maxlength"
                        class="tw-pt-3 tw-pb-3"
                    >
                        {{ "ADDRESS" | translate }}
                        {{ "ERROR.MUST_NOT_BE_MORE_THAN_100_CHAR" | translate }}
                    </span>
                </div>
            </div>
            <div>
                <label class="tw-text-xs tw-font-[500] tw-mb-[5px]" for="file_input">{{ "UPLOAD_FILE" | translate }}</label>
                <input
                    class="tw-w-full tw-cursor-pointer"
                    for="file_input"
                    type="file"
                    (change)="onFileSelected($event)"
                    class="file-input"
                    accept=".jpg, .jpeg, .png, .pdf"
                    #fileUpload
                >

                <div class="file-upload">
                    <button mat-flat-button color="primary" class="upload-btn tw-w-[10rem]" (click)="fileUpload.click()"><span class="tw-text-[16px]">{{ "CHOOSE_FILE" | translate }}</span></button>
                    <span class="tw-text-[16px] tw-pl-[20px]">{{fileName || "NO_FILE_CHOSEN" | translate}}</span>
                    <mat-icon class="cancel-upload tw-cursor-pointer" (click)="cancelUpload()" *ngIf="fileName">delete_forever</mat-icon>
                </div>
            </div>
            <div
                class="tw-flex tw-flex-wrap lg:tw-flex-nowrap tw-gap-5 md:tw-gap-10 tw-items-center tw-justify-center"
            >
                <div
                    class="tw-text-left tw-px-5 tw-text-sm md:tw-text-base md:tw-px-0"
                >
                    {{ "SUPPORT.SUPPORT_SUBMIT_MESSAGE" | translate }}
                </div>
                <button
                    ga-event-id="submit_enquiry_button_hp_click"
                    ga-event-category="Business Form Button"
                    ga-event-label="Submit Enquiry Support Button"
                    ga-track="track"
                    class="tw-text-white tw-text-xl tw-bg-gradient-to-r tw-from-[#FFA53C] tw-to-[#FFC53C] tw-py-[1.1rem] tw-basis-[{{ charLimit }}%] lg:tw-basis[50%] tw-whitespace-nowrap tw-rounded-[3rem] tw-px-[2.2rem] 2xl:tw-px-[2.5rem]"
                    type="submit"
                    [disabled]="clicked"
                    (click)="onSubmit()" 
                >
                    {{ "COMMON.SUBMIT" | translate }}
                </button>
            </div>
        </div>
    </form>
</div>
<div
    *ngIf="submittedSuccessfully"
    (click)="closeMegaMenuCondition()"
    class="tw-hidden md:tw-hidden lg:tw-block"
>
    <div
        class="tw-flex tw-justify-center tw-gap-[6vw] md:tw-mt-[3rem] tw-px-[2rem] tw-py-[2rem]"
    >
        <div class="tw-mt-20">
            <div class="tw-flex tw-items-center tw-justify-center">
                <img
                    src="/assets/images/icons/Done.png"
                    alt="logo"
                    class="tw-h-auto tw-w-[64px] lg:tw-w-[64px]"
                />
            </div>
            <div class="tw-flex tw-items-center tw-justify-center">
                <div class="tw-text-[24px] tw-font-semibold tw-h-[32px] tw-mt-[40px]">
                    {{ "THANK_YOU" | translate }}
                </div>
            </div>
            <div class="tw-flex tw-items-center tw-justify-center">
                <div class="tw-text-[16px] tw-text-gray-400 tw-font-medium tw-h-[24px] tw-mt-[40px]">
                    {{ "REDIRECTION_MESSAGE" | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
<div
    *ngIf="submittedSuccessfully"
    (click)="closeMegaMenuCondition()"
    class="tw-block sm:tw-block lg:tw-hidden"
>
    <div
        class="tw-flex tw-justify-center tw-gap-[6vw] md:tw-mt-[3rem] tw-px-[2rem] tw-py-[2rem]"
    >
        <div class="tw-mt-20">
            <div class="tw-flex tw-items-center tw-justify-center">
                <img
                    src="/assets/images/icons/Done.png"
                    alt="logo"
                    class="tw-h-auto tw-w-[64px] lg:tw-w-[64px]"
                />
            </div>
            <div class="tw-flex tw-items-center tw-justify-center">
                <div class="tw-text-[24px] tw-font-semibold tw-h-[32px] tw-mt-[40px]">
                    {{ "THANK_YOU" | translate }}
                </div>
            </div>
            <div class="tw-flex tw-items-center tw-justify-center tw-mb-[40px]">
                <div class="tw-text-[16px] tw-text-gray-400 tw-font-medium tw-h-[24px] tw-mt-[40px] tw-text-center">
                    {{ "REDIRECTION_MESSAGE" | translate }}
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer (click)="closeMegaMenuCondition(); updateSubmitButton()" [selectedLanguage]="languageSelected"></app-footer>
